export function getParams() {
    if(location.href.indexOf("uniform.bibachina.org") >= 0){
        return 'https://uniform.bibachina.org/mobile'
    }else if(location.href.indexOf("10.10.10.223") >= 0){
        return 'http://10.10.10.223:7001/mobile'
    }else {
        return 'https://uniform.bibachina.org/mobile'
    }
}
export let service_url = getParams()
